import React, {
  type PropsWithChildren,
  createContext,
  useContext,
} from "react";

import { atom, useAtom } from "jotai";
import { ScopeProvider } from "jotai-scope";

interface Props {
  maxIndentLevel: number;
}

const MaxIndentLevelContext = createContext(0);

export const MaxIndentLevelProvider = ({
  maxIndentLevel,
  children,
}: PropsWithChildren<Props>) => (
  <MaxIndentLevelContext.Provider value={maxIndentLevel}>
    {children}
  </MaxIndentLevelContext.Provider>
);

export const useMaxIndentLevel = () => {
  const context = useContext(MaxIndentLevelContext);

  if (context === undefined) {
    throw new Error(
      "useMaxIndentLevel must be used within a MaxIndentLevelProvider",
    );
  }

  return context;
};

type ExpandedRowIds = string[];
const expandedRowIdsAtom = atom<ExpandedRowIds>([]);
export const useExpandedRowIds = () => {
  return useAtom(expandedRowIdsAtom);
};

type AllSelectedRowIds = string[];
const allSelectedRowIdsAtom = atom<AllSelectedRowIds>([]);
export const useAllSelectedRowIds = () => {
  return useAtom(allSelectedRowIdsAtom);
};

export const PerformanceTrackingAtomsProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  return (
    <ScopeProvider atoms={[expandedRowIdsAtom, allSelectedRowIdsAtom]}>
      {children}
    </ScopeProvider>
  );
};
